import React, { Component } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string,
  onClose: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
};

const defaultProps = {
  icon: '',
  title: '',
  onClose: false,
};

const modalIsOpenClass = 'o-bb-modal--is-open';

class ModalHeader extends Component {
  componentDidMount() {
    document.body.classList.add(modalIsOpenClass);
  }

  componentWillUnmount() {
    document.body.classList.remove(modalIsOpenClass);
  }

  render() {
    const {
      icon,
      title,
      onClose,
    } = this.props;
    return (
      <header className="o-bb-modal__header">
        <h1 className="o-bb-modal__header-title">{icon && <i className={icon} />} {title}</h1>
        {onClose &&
          <i onClick={onClose} className="o-bb-modal__close icon-close" />
        }
      </header>
    );
  }
}

ModalHeader.propTypes = propTypes;
ModalHeader.defaultProps = defaultProps;

export { ModalHeader as default };



// WEBPACK FOOTER //
// ./src/components/Modals/ModalHeader.js